import React from 'react'

const AppFooter = () => {
  return (
    <div className="main-footer">
      <p>
        Powered by&nbsp;
        <a href="https://www.digisinergy.ro/" target="_blank" rel="noopener noreferrer">
          Digisinergy
        </a>
      </p>
    </div>
  )
}

export default React.memo(AppFooter)
